import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import "@/util/element-ui.js";
import "@/styles/reset-css.css";

// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
// Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
Vue.use(ElementUI);
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
